import { getStatus } from "../../../components/columns/get-status";
import { customerText } from "../../../components/Seo/whitelabel/bybest/bybest-customer-layout";

export const columns = [
  {
    title: customerText("brand"),
    dataIndex: "brand",
    key: "brand",
    render: (brand) => (
      <p className="text-14 text-[#667085] leading-5 font-medium">{brand}</p>
    ),
  },
  {
    title: customerText("type"),
    dataIndex: "type",
    key: "type",
    render: (type) => (
      <p className="text-14 text-[#667085] leading-5 font-medium">{type}</p>
    ),
  },
  {
    title: customerText("expiryDate"),
    dataIndex: "expiryDate",
    key: "expiryDate",
    render: (date) => (
      <p className="text-14 text-[#667085] leading-5 font-medium">{date}</p>
    ),
  },
  {
    title: customerText("promo"),
    dataIndex: "promo",
    key: "promo",
    render: (promo) => (
      <p className="text-14 text-[#240b3b] leading-5 font-bold">{promo}</p>
    ),
  },
  {
    title: customerText("status"),
    dataIndex: "status",
    key: "status",
    render: getStatus,
  },
];

export const dataSource = [
  {
    key: "1",
    brand: "Swatch",
    type: "Discount",
    expiryDate: "15/10/2024",
    promo: "SWATCH15",
    status: customerText("active"),
  },
  {
    key: "2",
    brand: "Swarovski",
    type: "Discount",
    expiryDate: "15/10/2024",
    promo: "SW30OFF",
    status: customerText("active"),
  },
  {
    key: "3",
    brand: "All Brands",
    type: "Coupon",
    expiryDate: "15/10/2024",
    promo: "BBVRTC752XL",
    status: customerText("active"),
  },
  {
    key: "4",
    brand: "Swatch",
    type: "Discount",
    expiryDate: "15/10/2024",
    promo: "SWATCH15",
    status: customerText("active"),
  },
  {
    key: "5",
    brand: "Swarovski",
    type: "Discount",
    expiryDate: "15/10/2024",
    promo: "SW30OFF",
    status: customerText("active"),
  },
  {
    key: "6",
    brand: "All Brands",
    type: "Coupon",
    expiryDate: "15/10/2024",
    promo: "BBVRTC752XL",
    status: customerText("active"),
  },
  {
    key: "7",
    brand: "Swatch",
    type: "Discount",
    expiryDate: "15/10/2024",
    promo: "SWATCH15",
    status: customerText("active"),
  },
  {
    key: "8",
    brand: "Swarovski",
    type: "Discount",
    expiryDate: "15/10/2024",
    promo: "SW30OFF",
    status: customerText("active"),
  },
  {
    key: "9",
    brand: "All Brands",
    type: "Coupon",
    expiryDate: "15/10/2024",
    promo: "BBVRTC752XL",
    status: customerText("active"),
  },
  {
    key: "10",
    brand: "Swatch",
    type: "Discount",
    expiryDate: "15/10/2024",
    promo: "SWATCH15",
    status: customerText("active"),
  },
  {
    key: "11",
    brand: "Swarovski",
    type: "Discount",
    expiryDate: "15/10/2024",
    promo: "SW30OFF",
    status: customerText("active"),
  },
  {
    key: "12",
    brand: "All Brands",
    type: "Coupon",
    expiryDate: "15/10/2024",
    promo: "BBVRTC752XL",
    status: customerText("active"),
  },
  {
    key: "13",
    brand: "Swatch",
    type: "Discount",
    expiryDate: "15/10/2024",
    promo: "SWATCH15",
    status: customerText("active"),
  },
  {
    key: "14",
    brand: "Swarovski",
    type: "Discount",
    expiryDate: "15/10/2024",
    promo: "SW30OFF",
    status: customerText("active"),
  },
  {
    key: "15",
    brand: "All Brands",
    type: "Coupon",
    expiryDate: "15/10/2024",
    promo: "BBVRTC752XL",
    status: customerText("active"),
  },
  {
    key: "16",
    brand: "Swatch",
    type: "Discount",
    expiryDate: "15/10/2024",
    promo: "SWATCH15",
    status: customerText("active"),
  },
  {
    key: "17",
    brand: "Swarovski",
    type: "Discount",
    expiryDate: "15/10/2024",
    promo: "SW30OFF",
    status: customerText("active"),
  },
  {
    key: "18",
    brand: "All Brands",
    type: "Coupon",
    expiryDate: "15/10/2024",
    promo: "BBVRTC752XL",
    status: customerText("active"),
  },
  {
    key: "19",
    brand: "Swatch",
    type: "Discount",
    expiryDate: "15/10/2024",
    promo: "SWATCH15",
    status: customerText("active"),
  },
  {
    key: "20",
    brand: "Swarovski",
    type: "Discount",
    expiryDate: "15/10/2024",
    promo: "SW30OFF",
    status: customerText("active"),
  },
  {
    key: "21",
    brand: "All Brands",
    type: "Coupon",
    expiryDate: "15/10/2024",
    promo: "BBVRTC752XL",
    status: customerText("active"),
  },
  {
    key: "22",
    brand: "Swatch",
    type: "Discount",
    expiryDate: "15/10/2024",
    promo: "SWATCH15",
    status: customerText("active"),
  },
  {
    key: "23",
    brand: "Swarovski",
    type: "Discount",
    expiryDate: "15/10/2024",
    promo: "SW30OFF",
    status: customerText("active"),
  },
  {
    key: "24",
    brand: "All Brands",
    type: "Coupon",
    expiryDate: "15/10/2024",
    promo: "BBVRTC752XL",
    status: customerText("active"),
  },
];
